import { Box, Button, Grid } from "@mui/material"
import ZoomOnView from "../../Animations/ZoomOnView"
import smallCap from '../../images/flying_otus.jpg'
import globalSmallCap from '../../images/global_small_cap.jpg'
import Tracker from '../Tracker'
import { COLOURS, otusButtonStyleGreen, otusButtonStyleWhite } from "../../variables"

const strategies = [
    {
        name: 'Otus Smaller Companies Strategy',
        image: smallCap,
        description: 'Launched in 2004, our European smaller companies strategy is focused on small and mid-sized companies in continental Europe. Fundamental bottom-up stock picking is combined with robust portfolio construction designed to protect capital, which results in an actively managed portfolio. This is implemented in a range of portfolios including variable net long/short and long-only.'
    },
    {
        name: 'Maga Micro Cap Strategy',
        image: 'https://images.unsplash.com/photo-1457530378978-8bac673b8062?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8',
        description: 'The Micro Cap strategy launched in 2013 and is a long-only, value-orientated stock picking strategy based on deep research and a collaborative activist approach. This strategy seeks to exploit the inefficiencies in the sub-EUR 250m market cap European universe.'
    },
    {
        name: 'Otus Global Smaller Companies Strategy',
        image: globalSmallCap,
        description: 'The Otus Global Smaller Companies strategy launched in July 2026 and employs a long-only, quality-value approach to investing in smaller companies across global developed markets. This strategy focuses on resilient businesses with low leverage, and aims to exploit inefficiencies in the sub-$10 billion market cap global universe.'
    },
]

const Strategy = ({ strategy, index }) => {
    const isEven = index % 2 === 0;

    const TextBox = () => (
        <Box sx={{ pl: { xs: 3, md: isEven ? 10 : 6 }, pr: { xs: 3, md: 6 }, py: { xs: 4, md: 6 } }}>
            <Box sx={{
                display: 'inline-block',
                fontSize: 10,
                fontWeight: 600,
                letterSpacing: '0.2em',
                textTransform: 'uppercase',
                opacity: 0.65,
                mb: 2,
            }}>
                Strategy
            </Box>
            <h2 style={{
                fontSize: 'clamp(22px, 2.4vw, 32px)',
                fontWeight: 500,
                lineHeight: 1.25,
                marginTop: 0,
                marginBottom: 20,
                letterSpacing: '-0.01em',
            }}>
                {strategy.name}
            </h2>
            <p style={{
                fontSize: 15,
                lineHeight: 1.85,
                opacity: 0.82,
                marginBottom: 32,
                maxWidth: 520,
                fontWeight: 300,
            }}>
                {strategy.description}
            </p>
            <Button
                href={`mailto:clientservices@otuscapital.com?subject=${encodeURIComponent(strategy.name + ' Information Request')}`}
                variant='outlined'
                sx={{ ...(isEven ? otusButtonStyleWhite : otusButtonStyleGreen), textDecoration: 'none', fontSize: 10, letterSpacing: '0.18em' }}
            >
                Request more details
            </Button>
        </Box>
    );

    const ImageBox = () => (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', height: '100%', pl: { xs: 2, md: isEven ? 4 : 6 }, pr: { xs: 2, md: isEven ? 10 : 4 }, pt: { xs: 3, md: 5 }, pb: { xs: 2, md: 4 } }}>
            <img
                src={strategy.image}
                alt={strategy.name}
                style={{
                    width: '100%',
                    maxWidth: 480,
                    height: 340,
                    objectFit: 'cover',
                    display: 'block',
                }}
            />
        </Box>
    );

    return (
        <Grid
            container
            alignItems='stretch'
            sx={{ backgroundColor: isEven ? COLOURS.fontColor : 'white', color: isEven ? 'white' : COLOURS.fontColor }}
        >
            <Grid item xs={12} sm={6}>
                <ZoomOnView side="left" bottomOffset={'10%'}>
                    {isEven ? <TextBox /> : <ImageBox />}
                </ZoomOnView>
            </Grid>
            <Grid item xs={12} sm={6}>
                <ZoomOnView side="right" bottomOffset={'10%'}>
                    {isEven ? <ImageBox /> : <TextBox />}
                </ZoomOnView>
            </Grid>
        </Grid>
    );
}

export default function Strategies({ navHeight }) {
    return (
        <div style={{ paddingTop: navHeight }}>
            <Tracker page='Strategies' />
            {strategies.map((strategy, index) => (
                <Strategy key={strategy.name} strategy={strategy} index={index} />
            ))}
        </div>
    );
}